import DashboardLayout from "@/pages/Layout/DashboardLayout.vue";
import Auth from "@/pages/Auth.vue";

import Dashboard from "@/pages/Dashboard.vue";
import MyFiles from "@/pages/myFiles.vue";
import CaseEvidence from "@/pages/caseEvidence.vue";
import EvidenceManager from "@/pages/evidenceManager.vue";
import EvidenceManagerPresident from "@/pages/evidenceManagerPresidents.vue";
import Notifications from "@/pages/Notifications.vue";
import sentencing from "@/pages/Sentencing.vue";

const routes = [
  {
    path: "/auth",
    name: "Auth",
    component: Auth,
  },
  {
    path: "/evidence-review",
    name: "EvidenceReview",
    component: EvidenceManager,
    meta: {
      requiresAuthContext: true,
    },
  },
  {
    path: "/evidence-review/president",
    name: "EvidenceReview",
    component: EvidenceManagerPresident,
    meta: {
      requiresAuthContext: true,
    },
  },
  {
    path: "/",
    component: DashboardLayout,
    redirect: "/dashboard",
    meta: {
      requiresAuthContext: true,
    },
    children: [
      {
        path: "dashboard",
        name: "Dashboard",
        component: Dashboard,
      },
      {
        path: "files",
        name: "Mis Archivos",
        component: MyFiles,
      },
      {
        path: "sentencing",
        name: "Sentencias",
        component: sentencing,
      },
      {
        path: "evidence",
        name: "Evidencias",
        component: CaseEvidence,
      },
      {
        path: "notifications",
        name: "Notificaciones",
        component: Notifications,
      },
    ],
  },
];

export default routes;
